import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';

import { securityAuthenticationChangeEmailReducers, securityAuthenticationChangeEmailWatchers } from './change-email';
import { securityAuthenticationEnrollReducers, securityAuthenticationEnrollWatchers } from './enroll';
import {
	securityAuthenticationForgotPasswordReducers,
	securityAuthenticationForgotPasswordWatchers
} from './forgot-password';
import { securityAuthenticationLoginReducers, securityAuthenticationLoginWatchers } from './login';
import { securityAuthenticationLogoutReducers, securityAuthenticationLogoutWatchers } from './logout';
import {
	securityAuthenticationResetPasswordReducers,
	securityAuthenticationResetPasswordWatchers
} from './reset-password';

export const securityAuthenticationReducers = combineReducers({
	changeEmail: securityAuthenticationChangeEmailReducers,
	enroll: securityAuthenticationEnrollReducers,
	forgotPassword: securityAuthenticationForgotPasswordReducers,
	login: securityAuthenticationLoginReducers,
	logout: securityAuthenticationLogoutReducers,
	resetPassword: securityAuthenticationResetPasswordReducers
});

export const securityAuthenticationWatchers = combineAllWatchers([
	securityAuthenticationChangeEmailWatchers,
	securityAuthenticationEnrollWatchers,
	securityAuthenticationForgotPasswordWatchers,
	securityAuthenticationLoginWatchers,
	securityAuthenticationLogoutWatchers,
	securityAuthenticationResetPasswordWatchers
]);
